import { every } from "lodash";

import store from "@/store";

const idAttribute = "organizationId";

export const organizationFactory = organizationApi => ({
  actions: {
    async create({ dispatch }, data) {
      const organization = await organizationApi.create(data);
      dispatch("list");
      return organization;
    },
    async getByGuid({ commit }, organizationGuid) {
      const guidRecord = await organizationApi.getByGuid(organizationGuid);
      return commit("setGuidRecord", guidRecord);
    },
    async getByOrganizationId({ commit, state }, organizationId) {
      const record = await organizationApi.getByOrganizationId(organizationId);
      return commit("setRecord", record);
    },
    async list({ commit, state }, { reload = true } = { reload: true }) {
      if ((!state.list.length && !state.listPromise) || reload) {
        commit("setListPromise", organizationApi.list());
        const list = await state.listPromise;
        commit("setList", list);
        commit("setListPromise", null);
      } else if (state.listPromise) {
        await state.listPromise;
      }
      return state.list;
    },

    async listAdmin({ commit }) {
      const list = await organizationApi.listAdmin();
      return commit("setListAdmin", list);
    },
    async syncUsers(context, organizationId) {
      const importedUserList = await organizationApi.syncUsers(organizationId);
      if (importedUserList.length) {
        await store.dispatch("user/list");
      }
      return importedUserList;
    },
    async update({ commit, dispatch, state }, [id, data]) {
      const record = await organizationApi.update(id, data);

      commit("setRecord", record);
      await dispatch("list");

      return state.record;
    },
  },
  getters: {
    filter: state => (filterMap, id) => {
      if (id) {
        filterMap = Object.assign({}, filterMap, { [idAttribute]: id });
      }

      const filteredList = state.list.filter(item => {
        return every(filterMap, (filterValue, filterAttribute) => {
          return item[filterAttribute] === filterValue;
        });
      });

      return filteredList;
    },
    find: state => (filterMap, id) => {
      if (id) {
        filterMap = Object.assign({}, filterMap, { [idAttribute]: id });
      }

      return state.list.find(item => {
        return every(filterMap, (filterValue, filterAttribute) => {
          return item[filterAttribute] === filterValue;
        });
      });
    },
    getById: state => findId => {
      return state.list.find(item => {
        return item.organizationId === findId;
      });
    },
    getShareableLink: state => id => {
      const organization = state.list.find(org => org.organizationId === id);
      if (!organization) {
        return null;
      }
      return `/member/account/${organization.organizationGuid}/create-account`;
    },
  },
  mutations: {
    setAttribute(state, [entityId, attribute, value]) {
      const entity = state.list.find(
        organization => organization.organizationId === entityId
      );

      if (!entity) {
        throw new Error(`No organizationId with id of ${entityId}`);
      }

      entity[attribute] = value;
    },
    setGuidRecord(state, guidRecord) {
      state.guidRecord = guidRecord;
    },
    setList(state, list) {
      state.list = list;
    },
    setListAdmin(state, list) {
      state.listAdmin = list;
    },
    setListPromise(state, value) {
      state.listPromise = value;
    },
    setOchinCoreTeamList(state, list) {
      state.ochinCoreTeamList = list;
    },
    setRecord(state, record) {
      state.record = record;
    },
  },
  namespaced: true,
  state: {
    guidRecord: {},
    list: [],
    listAdmin: [],
    listPromise: null,
    ochinCoreTeamList: [],
    record: null,
  },
});
